import axios from "axios";

import store from "features/store";
import { getBuyerHeaders, getBuyersUrl } from "shared/http";
import { bidsSseEvent, bidsSseEventAdd } from "shared/settings/apiconfig";

class SSEManager {

    constructor() {
        this.eventSource = null;
        this.clientId = Date.now() + Math.floor(100000 + Math.random() * 900000);
        this.itemIds = [];
        this.isNetworkAvailable = true;

        store.subscribe(() => {
            const state = store.getState();
            const previousNetworkState = this.isNetworkAvailable;
            
            this.isNetworkAvailable = !state.showOffilePopUp;

            if ( previousNetworkState === false && this.isNetworkAvailable === true ) {
                setTimeout(() => {
                    this.init();
                }, 2000);
            }
        });
    }

    /**
     * 
     * @description This method will initialize sse connection
     */
    init() {
        if ( this.isNetworkAvailable ) {
            if ( this.eventSource === null ) {
                this.eventSource = new EventSource(`${getBuyersUrl(bidsSseEvent)}${this.clientId}`);
    
                this.eventSource.onopen = (event) => {
                    this.listen();
                }
        
                this.eventSource.onmessage = (event) => {
                    if ( typeof event.data === 'string' ) {
                        let data = JSON.parse(event.data);
                        if ( typeof data === 'object' ) {
                            store.dispatch({ type: 'BIDS', payload: data.itemIds });
                        }
                    }
                };
        
                this.eventSource.onerror = (err) => {
                    this.eventSource.close();
                    this.eventSource = null;
                    this.init();
                };
            } else {
                this.listen();
            }
        }
    }

    /**
     * 
     * @description This method will update the item list in this.itemIds and initialize sse connection, see item add api.
     */
    connect(itemIds, append=false) {
        if ( Array.isArray(itemIds) && itemIds.length > 0 ) {
            if ( append ) {
                const sortedNewList = Array.from(new Set([...this.itemIds, ...itemIds])).sort();
                if ( JSON.stringify(this.itemIds) === JSON.stringify(sortedNewList) ) {
                    return;
                } else {
                    this.itemIds = Array.from(new Set([...this.itemIds, ...itemIds])).sort();
                }
            } else {
                this.itemIds = itemIds.sort();
            }

            this.init();
        }
    }

    /**
     * 
     * @description This method will call sse item add api for listening bid events.
     */
    listen() {
        if ( this.eventSource ) {
            axios.post(getBuyersUrl(bidsSseEventAdd + this.clientId), JSON.stringify({ data: { itemIds: this.itemIds } }), getBuyerHeaders()).then(response => {
            }).catch(error => {
            });
        }
    }

    /**
     * 
     * @description This method will call sse item add api for removing bid listening.
     */
    ignore() {
        if ( this.eventSource ) {
            this.itemIds = [];
            axios.post(getBuyersUrl(bidsSseEventAdd + this.clientId), JSON.stringify({ data: { itemIds: [] } }), getBuyerHeaders()).then(response => {
            }).catch(error => {
            });
        }
    }
}

export const bidEventManager = new SSEManager();